import { Component, OnInit } from '@angular/core';
import { VoucherService, VoucherRedeemModel, BalanceService, config, ErrorStateService, ScreenType } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
  animations: [
      trigger('flyInOut', [
        state(
          'inactive',
          style({
            opacity: 0,
          })
        ),
        transition(
          ':enter',
          animate(
            '400ms ease-out',
            keyframes([
              style({
                transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                opacity: 0,
              }),
              style({
                transform: 'skewX(20deg)',
                opacity: 1,
              }),
              style({
                transform: 'skewX(-5deg)',
                opacity: 1,
              }),
              style({
                transform: 'none',
                opacity: 1,
              }),
            ])
          )
        ),
        transition(
          ':leave',
          animate(
            '400ms ease-out',
            keyframes([
              style({
                opacity: 1,
              }),
              style({
                transform: 'translate3d(100%, 0, 0) skewX(30deg)',
                opacity: 0,
              }),
            ])
          )
        ),
      ]),
    ],
})
export class VouchersComponent implements OnInit {
  screenSize = ScreenType;
  voucherCode: string;
  redemptionResult: string;
  successMessage: string = this.translate.instant('voucher.process.code');
  disableButton: boolean;
  successfulRedemption: boolean;
  isEmptyVoucher: boolean = false;
  private messageTimeout: NodeJS.Timeout;

  constructor(
    private voucherService: VoucherService,
    private balanceService: BalanceService,
    public errorService: ErrorStateService,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  redeemVoucher() {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
    this.clearMessages();
    this.successfulRedemption = false;
    this.disableButton = true;

    if (!this.voucherCode) {
      this.redemptionResult = this.translate.instant('voucher.code.empty.text');
      this.disableButton = false;
      this.isEmptyVoucher = true;
      this.clearMessagesAfter(10000);
      return;
    }

    let voucher = new VoucherRedeemModel();
    voucher.VoucherCode = this.voucherCode;
    this.voucherService
      .redeemVoucher(voucher)
      .toPromise()
      .then((item) => {
        this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).pipe(take(1)).subscribe();
        this.redemptionResult = this.successMessage;
        this.successfulRedemption = true;
      })
      .finally(() => {
        this.disableButton = false;
        this.clearMessagesAfter(10000);
      });
  }

  private clearMessagesAfter(timeAfter: number) {
    this.messageTimeout = setTimeout(() => {
      this.clearMessages();
    }, timeAfter);
  }

  private clearMessages() {
    this.redemptionResult = '';
    this.errorService.clearErrors();
  }
}
